import React from "react";
import Slider from "react-infinite-logo-slider";
import { useTranslation } from 'react-i18next';
import ScrollAnimation from "react-animate-on-scroll";
const Integrations = () => {
    const { t } = useTranslation();
    const integrations = [
        {
            name: "Wolt",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/integrations_images/wolt.png",
            height: 25,
            href: "https://wolt.com/hu/hun/?utm_source=www.happysolution.hu",
        },
        {
            name: "Foodora",
            image:
        "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/integrations_images/Foodora_Logo_Cherry%20Pink_RGB.png",
            height: 50,
            href: "https://www.foodora.hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Novopayment",
            image:
          "/images/logo/novopayment.png",
            height: 68,
            href: "https://novopayment.hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Viva payments",
            image:
          "https://mma.prnewswire.com/media/2162532/Viva_Wallet_Logo.jpg?p=twitter",
            height: 37,
            href: "https://www.vivawallet.com/hu_hu/?utm_source=www.happysolution.hu",
        },

        {
            name: "Teya",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/integrations_images/teya.png",
            height: 40,
            href: "https://www.teya.com/hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Stripe",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/integrations_images/stripe.png",
            height: 55,
            href: "https://stripe.com/en-hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "MyPOS",
            image:
          "https://www.mypos.com/info2/info_common/images/logo/logo-header.webp",
            height: 45,
            href: "https://www.mypos.com/hu-hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Shopify",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/HappyWeb/images/shopify_logo_black.png",
            height: 45,
            href: "https://www.shopify.com/hu?utm_source=www.happysolution.hu",
        },
        {
            name: "Base.com",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/HappyWeb/images/logo-base-baselinker.png",
            height: 45,
            href: "https://www.base.com/?utm_source=www.happysolution.hu",
        },
        {
            name: "iLogistic",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/HappyWeb/images/ilog_login_logo.png",
            height: 45,
            href: "https://ilogistic.eu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Számlázz",
            image:
          "https://www.szamlazz.hu/wp-content/uploads/2023/09/szamlazzhu_logo-horizontal-1_color.png",
            height: 56,
            href: "https://www.szamlazz.hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Billingo",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/integrations_images/billingo.png",
            height: 30,
            href: "https://www.billingo.hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Online Számla",
            info: "Online Számla rendszer, NAV",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsnX2GD5PmJR014CnVf10sSudAznLI0p8Zcw&s",
            href: "https://onlineszamla.nav.gov.hu/?utm_source=www.happysolution.hu/",
            height: 40,
        },
        {
            name: "Wolt Drive",
            image:
              "https://d21buns5ku92am.cloudfront.net/69308/images/480851-WoltDrive_pill_logo-a8aec6-large-1683188291.png",
            height: 40,
            href: "https://explore.wolt.com/hu/hun/wolt-drive/?utm_source=www.happysolution.hu",
        },
        {
            name: "GLS",
            image:
              "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/HappyWeb/images/GLS_Logo_2021_RGB_GLSBlue.png",
            height: 40,
            href: "https://gls-group.com/HU/hu/home/?utm_source=www.happysolution.hu",
        },
        {
            name: "UPS",
            image:
              "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/HappyWeb/images/ups-united-parcel-service-vector-logo-seeklogo.zip",
            height: 40,
            href: "https://www.ups.com/?utm_source=www.happysolution.hu",
        },
        {
            name: "iBar",
            info: "Leltározás és standolás éttermeknek",
            image: "https://static.wixstatic.com/media/36b443_d327d78c2c034adcb1cdbec57d24b8a7~mv2.png/v1/fill/w_188,h_98,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/ibar_smart_white_edited.png",
            href: "https://www.ibar.ai/?utm_source=www.happysolution.hu",
            height: 40,
            filter: "invert(1)",
        },
        {
            name: "Querko",
            image:
          "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/integrations_images/qerko.webp",
            height: 50,
            href: "https://www.qerko.com/hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "MyTyx",
            image:
        "https://mytix.hu/assets/img/logo.png",
            height: 52,
            href: "https://mytix.hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Vemoco",
            image:
        "https://www.vemoco.com/uploads/images/vemoco_logo.png",
            height: 37,
            href: "https://www.vemoco.com/hu/home-hu/?utm_source=www.happysolution.hu",
        },
        {
            name: "Falatozz",
            image:
        "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/integrations_images/falatozzhu_logo_szines_v2.svg",
            height: 33,
            href: "https://falatozz.hu/?utm_source=www.happysolution.hu",
        },
    ];

    return (
        <div style={{ padding: "20px 0 20px 0" }}>
            <h3
                className={"title"}
                style={{
                    whiteSpace: "nowrap",
                    textAlign: "center" 
                }}
            >
                {t('partners.title')}
            </h3>
            <div className="integrations-slider">
                <Slider
                    width="200px"
                    duration={55}
                    pauseOnHover={true}
                    blurBorders={true}
                    blurBoderColor={"#FFF"}
                >
                    {integrations.map((integration, index) => (
                        <Slider.Slide style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: "24px",
                            marginLeft: "24px" 
                        }}>
                            <a
                                href={integration.href}
                                rel={"noreferrer"}
                                target={"_blank"}
                                className="integration-logo"
                                key={index}
                            >
                                <img
                                    src={integration.image}
                                    alt={integration.name}
                                    style={{
                                        height: integration.height,
                                        filter: integration.filter 
                                    }}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </a>
                        </Slider.Slide>
                    ))}
                </Slider>
            </div>
            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" animateOnce={true} delay={150}>
                <div style={{
                    margin: "24px auto 0",
                    textAlign: "center",
                    padding: "24px 20px",
                    maxWidth: 960,
                    background: "linear-gradient(180deg, #fff9e6 0%, #ffffff 100%)",
                    border: "1px solid #f1b44c",
                    borderRadius: 16,
                    boxShadow: "0 8px 24px rgba(0,0,0,.06)" 
                }}>
                    <p style={{
                        margin: 0,
                        fontSize: 18,
                        lineHeight: 1.5 
                    }}>
                        <span role="img" aria-label="handshake">🤝</span> <strong>{t('partners.cta.question')}</strong>
                        <br/>
                        {t('partners.cta.contactIntro')}
                    </p>
                    <div style={{ marginTop: 12 }}>
                        <a
                            className="edu-btn"
                            href={"mailto:partner@happysolutions.hu?subject=Partneri%20%C3%A9rdekl%C5%91d%C3%A9s"}
                        >
                            <i className="ri-mail-line" style={{ marginRight: 6 }}></i>
                            {t('partners.cta.email')}
                        </a>
                    </div>
                </div>
            </ScrollAnimation>

        </div>
    );
};

export default Integrations;
